export default __webpack_public_path__ + "static/media/Picture8.65242488.png";